<app-new-modal [showModal]="showEditTicketModal" showSecondaryButton="true" title="ADD_EXISTING_TICKET"
    (close)="closeAddTicketModal()" primaryButtonText="ADD" width="50%" (primaryAction)="addTicket()"
    (secondaryAction)="closeAddTicketModal()" [primaryButtonDisabled]="!canAddTicket()">
    <div class="inp-wrap">
        <label for="nameInput">{{ 'NAME' | translate }}</label>
        <input type="text" class="form-control" id="nameInput" placeholder="Entrez votre nom" [(ngModel)]="newName" />
    </div>

    <div class="inp-wrap" style="margin-top: 10px;">
        <label for="pnrInput">{{ 'RESERVATION_REF' | translate }}</label>
        <input type="text" class="form-control" id="pnrInput" placeholder="N° Dossier" [(ngModel)]="newPnr" />
    </div>
</app-new-modal>

<section style="
        position: relative;
        text-align: center;
        color: white;
        margin-bottom: 40px;
    ">
    <img [src]="
            '/assets/algerie-booking/' +
            clientAssets +
            '/images/' +
            'cover.jpeg'
        " alt="" loading="lazy" style="
            width: 100%;
            height: 300px;
            object-fit: cover;
            mask-image: linear-gradient(
                rgba(255, 255, 255, 1) 70%,
                rgba(255, 255, 255, 0) 100%
            );
        " />
    <h1 style="
            position: absolute;
            z-index: 99;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
        ">
        {{ "BOOKINGS" | translate }}
    </h1>
</section>

<div class="container mt-5" style="margin-block: 40px">
    <ul class="nav nav-pills modern-tabs justify-content-center my-4" *ngIf="showTabs()">
        <li class="nav-item" *ngIf="showFlightTab()">
            <a class="nav-link" [class.active]="activeTab === 'flight'" (click)="changeTab('flight')">
                {{ "FLIGHTS" | translate }}
            </a>
        </li>
        <li class="nav-item" *ngIf="shoHotelTab()">
            <a class="nav-link" style="margin-inline-start: 10px;" [class.active]="activeTab === 'hotel'"
                (click)="changeTab('hotel')">
                {{ "HOTELS" | translate }}
            </a>
        </li>
    </ul>

    <!-- Flight Filters -->
    <div *ngIf="activeTab === 'flight'" class="filters-wrapper">
        <div class="filters-container">
            <div class="filter-item">
                <label>{{ "PNR" | translate }}</label>
                <input type="text" placeholder="Enter Pnr ..." [(ngModel)]="flightFilters.pnr" />
            </div>
            <!-- <div class="filter-item">
                <label>{{ "DEPARTURE" | translate }}</label>
                <input type="text" placeholder="Search ..." [(ngModel)]="flightFilters.departure" />
            </div>
            <div class="filter-item">
                <label>{{ "ARRIVAL" | translate }}</label>
                <input type="text" placeholder="Search ..." [(ngModel)]="flightFilters.arrival" />
            </div> -->
            <div class="filter-item filter-item--date">
                <label>{{ "DATE" | translate }}</label>
                <div class="date-group">
                    <select [(ngModel)]="flightFilters.dateType">
                        <option value="BOOKING">
                            {{ "BOOKING" | translate }}
                        </option>
                    </select>
                    <input [placeholder]="'FROM1' | translate" ngbDatepicker #firstDay_dp="ngbDatepicker"
                        [(ngModel)]="flightFilters.firstDay" readonly (click)="firstDay_dp.toggle()"
                        (ngModelChange)="onFromDateChange($event)" [maxDate]="today" />

                    <input [placeholder]="'TO1' | translate" ngbDatepicker #lastDay_dp="ngbDatepicker"
                        [(ngModel)]="flightFilters.lastDay" readonly (click)="lastDay_dp.toggle()"
                        [minDate]="flightFilters.firstDay" [maxDate]="today" />
                </div>
            </div>
        </div>
        <div class="filters-actions">
            <button [disabled]="flightsLoading" class="btn btn-sm btn-primary me-2"
                style="border-radius: 5px !important" (click)="applyFlightFilters()">
                {{ "SEARCH" | translate }}
            </button>
            <button [disabled]="flightsLoading" class="btn btn-sm btn-outline-secondary" (click)="clearFlightFilters()">
                {{ "RESET" | translate }}
            </button>
        </div>
    </div>
    <div *ngIf="activeTab === 'hotel'" class="filters-wrapper">
        <div class="filters-container">
            <div class="filter-item">
                <label>{{ "REF" | translate }}</label>
                <input type="text" placeholder="Enter reference..." [(ngModel)]="hotelFilters.reference" />
            </div>
            <div class="filter-item">
                <label>{{ "HOTEL_NAME" | translate }}</label>
                <input type="text" placeholder="Search hotel..." [(ngModel)]="hotelFilters.hotelName" />
            </div>
            <div class="filter-item filter-item--date">
                <label>{{ "DATE" | translate }}</label>

                <div class="date-group">
                    <select [(ngModel)]="hotelFilters.dateType">
                        <option value="BOOKING">
                            {{ "BOOKING" | translate }}
                        </option>
                        <option value="CHECKIN">
                            {{ "CHECK_IN" | translate }}
                        </option>
                        <option value="CHECKOUT">
                            {{ "CHECK_OUT" | translate }}
                        </option>
                    </select>

                    <input [placeholder]="'FROM1' | translate" ngbDatepicker #firstDay_dp="ngbDatepicker"
                        [(ngModel)]="hotelFilters.firstDay" readonly (click)="firstDay_dp.toggle()"
                        (ngModelChange)="onFromDateChange($event)" [maxDate]="today" />

                    <input [placeholder]="'TO1' | translate" ngbDatepicker #lastDay_dp="ngbDatepicker"
                        [(ngModel)]="hotelFilters.lastDay" readonly (click)="lastDay_dp.toggle()"
                        [minDate]="hotelFilters.firstDay" [maxDate]="today" />
                </div>
            </div>
        </div>
        <div class="filters-actions">
            <button class="btn btn-sm btn-primary me-2" style="border-radius: 5px !important"
                (click)="applyHotelFilters()" [disabled]="hotelsLoading">
                {{ "SEARCH" | translate }}
            </button>
            <button [disabled]="hotelsLoading" class="btn btn-sm btn-outline-secondary" (click)="clearHotelFilters()">
                {{ "RESET" | translate }}
            </button>
        </div>
    </div>

    <div class="card shadow-lg border-0 rounded-4">

        <div class="card-body p-4">
            <div *ngIf="activeTab === 'flight'">
                <div class=""
                    style="display: flex; align-items: center;justify-content: flex-end; margin-bottom: 20px;">
                    <button class="btn-primary add-ticket-btn" (click)="openAddTicketModal()">
                        <i class="fa fa-plus"></i>
                        {{ "ADD_EXISTING_TICKET" | translate }}
                    </button>
                </div>
                <ng-container *ngIf="flightsLoading; else flightLoadedBlock">
                    <div class="skeleton-card" *ngFor="let i of [1,2,3,4]">
                        <div class="skeleton skeleton-img"></div>
                        <div class="skeleton-body">
                            <div class="skeleton skeleton-title"></div>
                            <div class="skeleton skeleton-text"></div>
                            <div class="skeleton skeleton-text short"></div>
                        </div>
                        <div class="skeleton-footer">
                            <div class="skeleton skeleton-chip"></div>
                            <div class="skeleton skeleton-chip"></div>
                        </div>
                    </div>
                </ng-container>
                <ng-template #flightLoadedBlock>
                    <div class="text-start" style="margin-bottom: 10px; font-weight: 500"
                        *ngIf="flightBookingsList && flightBookingsList.length > 0">
                        <span class="confirmed">{{ totalFlightBookings }}</span>
                        {{ "SEARCH_AVAILABILITY_RESULT_FOUND" | translate }}
                    </div>
                    <div class="fl-ticket-list">

                        <article class="fl-ticket-card" *ngFor="let reservation of flightBookingsList.slice(
                                flightPaginationStart,
                                flightPaginationEnd
                            );">
                            <header class="fl-ticket-header">
                                <div class="fl-ticket-airline">
                                    <img class="fl-ticket-airline-logo"
                                        src="http://static.algebratec.com/assets/logos/airline/{{reservation.validatingCarrier}}.png"
                                        alt="airline" />
                                    <div class="fl-ticket-airline-name"
                                        *ngIf="airlineDict[reservation.validatingCarrier]">
                                        {{ airlineDict[reservation.validatingCarrier].airline }}
                                    </div>
                                </div>
                                <div *ngIf="reservation.date" style="text-align: center;font-size: 12px;" class="">
                                    {{ reservation.date }}
                                </div>
                                <div class="fl-ticket-price">
                                    {{ formatPrice(reservation.price) }}
                                    {{ reservation.currency || 'DZD' }}
                                </div>
                            </header>
                            <section class="fl-ticket-bound" *ngFor="let bound of reservation.bounds;let i=index;">
                                <div *ngIf="bound.segments && bound.segments.length"
                                    class="fl-ticket-airport fl-ticket-airport-left">
                                    <div class="fl-ticket-code">{{ bound.segments[0].from }}</div>
                                    <div class="fl-ticket-city"
                                        *ngIf="bound.segments[0].from && airportDict[bound.segments[0].from]">{{
                                        airportDict[bound.segments[0].from].city_name}}</div>
                                    <div class="fl-ticket-time">
                                        {{ bound.segments[0].departureDate.slice(0,-3) }}
                                    </div>
                                </div>
                                <div class="fl-ticket-flight-info">
                                    <div class="fl-ticket-duration">
                                        {{ cabinClass[bound.segments[0].cabin] | translate }}
                                    </div>

                                    <div class="fl-ticket-route">
                                        <span class="fl-ticket-dot"></span>
                                        <span class="fl-ticket-line"></span>
                                        <span class="fl-ticket-dot"></span>
                                    </div>

                                    <div class="fl-ticket-meta">
                                        <span>
                                            <ng-container *ngIf="bound.segments.length - 1 === 0; else withStop">
                                                {{ "DIRECT_FLIGHT" | translate }}
                                            </ng-container>
                                            <ng-template #withStop>
                                                {{ bound.segments.length - 1 }}
                                                {{ "STOPOVER" | translate }}
                                            </ng-template>
                                        </span>
                                        <span class="fl-ticket-bound-type" *ngIf="i === 1">
                                            {{ "OUT_BOUND" | translate}}
                                        </span>
                                        <span class="fl-ticket-bound-type" *ngIf="i !== 1">
                                            {{ "IN_BOUND" | translate}}
                                        </span>
                                    </div>
                                </div>

                                <div class="fl-ticket-airport fl-ticket-airport-right"
                                    *ngIf="bound.segments && bound.segments.length">
                                    <div class="fl-ticket-code">{{ bound.segments[bound.segments.length-1].to }}</div>
                                    <div class="fl-ticket-city"
                                        *ngIf="bound.segments[bound.segments.length-1].to &&  airportDict[bound.segments[bound.segments.length-1].to]">
                                        {{ airportDict[bound.segments[bound.segments.length-1].to].city_name }}</div>
                                    <div class="fl-ticket-time">
                                        {{ bound.segments[0].arrivalDate ? bound.segments[0].arrivalDate.slice(0,-3) :
                                        '--' }}
                                    </div>
                                </div>

                            </section>
                            <footer class="fl-ticket-footer">
                                <div *ngIf="reservation.status" class="fl-ticket-baggage" style="font-weight:bold;">
                                    {{ reservation.pnr }} - <span [ngClass]="reservation.status.toLowerCase()">{{
                                        reservation.status | translate }}</span>
                                </div>
                                <div class="fl-ticket-class"
                                    *ngIf="reservation.pnr && reservation.surname"
                                    style="color: var(--primary-color);font-weight: 500;cursor: pointer;"
                                    (click)="viewFlightBooking(reservation.pnr,reservation.surname)">
                                    {{ "VIEW_BOOKING" | translate }}
                                </div>
                            </footer>
                        </article>
                    </div>
                    <div class="empty-table text-center" *ngIf="!flightBookingsList || flightBookingsList.length == 0">
                        {{ "EMPTY_RECENT_BOOKINGS" | translate }}
                    </div>
                </ng-template>
                <app-custom-pagination [totalPages]="totalFlightPages" [currentPage]="currentFlightPage"
                    [itemPerPage]="itemsPerPageFlight" [perPagesList]="perPageList"
                    (pageChange)="changePageFlight($event)" (itemsPerPageChange)="setItemPerPageFlight($event)">
                </app-custom-pagination>
            </div>
            <!-- Hotel Bookings Table -->
            <div *ngIf="activeTab === 'hotel'">

                <ng-container *ngIf="hotelsLoading; else hotelLoadedBlock">
                    <div class="skeleton-card" *ngFor="let i of [1,2,3,4]">
                        <div class="skeleton skeleton-img"></div>
                        <div class="skeleton-body">
                            <div class="skeleton skeleton-title"></div>
                            <div class="skeleton skeleton-text"></div>
                            <div class="skeleton skeleton-text short"></div>
                        </div>
                        <div class="skeleton-footer">
                            <div class="skeleton skeleton-chip"></div>
                            <div class="skeleton skeleton-chip"></div>
                        </div>
                    </div>
                </ng-container>
                <ng-template #hotelLoadedBlock>
                    <div class="text-start" style="margin-bottom: 10px; font-weight: 500"
                        *ngIf="hotelBookingsList && hotelBookingsList.length > 0">
                        <span class="confirmed">{{ totalHotelBookings }}</span>
                        {{ "SEARCH_AVAILABILITY_RESULT_FOUND" | translate }}
                    </div>
                    <div class="hotel-cards">
                        <div class="hotel-card" *ngFor="let booking of hotelBookingsList">
                            <div class="hotel-card-image">
                                <img [src]="
                                    booking.hotelImage ||
                                    'assets/hotel-placeholder.jpg'
                                " alt="Hotel image" />
                            </div>

                            <div class="hotel-card-content">
                                <div class="hotel-card-header">
                                    <div>
                                        <h3 class="hotel-name">
                                            {{
                                            booking.hotelName ||
                                            "Hilton Algiers"
                                            }}
                                        </h3>
                                        <span class="reference">
                                            {{ "REF" | translate }}:
                                            {{ booking.reference || "HTL-983241" }}
                                        </span>
                                    </div>

                                    <span class="status-badge" [ngClass]="{
                                        'status-confirmed':
                                            booking.status === 'CONFIRMED',
                                        'status-cancelled':
                                            booking.status === 'CANCELED',
                                        'status-pending':
                                            booking.status === 'PENDING',
                                        'status-failed':
                                            booking.status === 'FAILED'
                                    }">
                                        {{ booking.status | translate }}
                                    </span>
                                </div>

                                <div class="hotel-card-info">
                                    <div class="info-item">
                                        <strong>
                                            {{ formatPrice(booking.price) }}
                                            {{ booking.currency || "DZD" }}</strong>
                                        <span class="info-label">{{
                                            "PRICE" | translate
                                            }}</span>
                                    </div>

                                    <div class="info-item">
                                        {{
                                        booking.bookingDate
                                        | date : "mediumDate"
                                        }}
                                        <span class="info-label">{{
                                            "BOOKING_DATE" | translate
                                            }}</span>
                                    </div>

                                    <div class="info-item">
                                        {{
                                        booking.checkInDate
                                        | date : "mediumDate"
                                        }}
                                        →
                                        {{
                                        booking.checkOutDate
                                        | date : "mediumDate"
                                        }}
                                        <span class="info-label">{{
                                            "STAY" | translate
                                            }}</span>
                                    </div>
                                </div>

                                <div class="hotel-card-actions">
                                    <button class="btn-outline" *ngIf="booking.type === 'booking'"
                                        (click)="viewHotelBooking(booking.reference)">
                                        <i class="fa fa-ticket" style="margin-inline-end: 5px;"></i>{{ "VIEW_BOOKING" |
                                        translate }}
                                    </button>
                                    <div class="type-badge  badge-request" *ngIf="booking.type === 'request'">
                                        <i class="fa fa-envelope" style="margin-inline-end: 5px;"></i>{{ "REQUEST" |
                                        translate }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="empty-table text-center" *ngIf="!hotelBookingsList || hotelBookingsList.length == 0">
                        {{ "EMPTY_RECENT_BOOKINGS" | translate }}
                    </div>
                </ng-template>
                <app-custom-pagination [totalPages]="totalHotelPages" [currentPage]="currentHotelPage"
                    [itemPerPage]="itemsPerPageHotel" [perPagesList]="perPageList"
                    (pageChange)="changePageHotel($event)" (itemsPerPageChange)="setItemPerPageHotel($event)">
                </app-custom-pagination>
            </div>
        </div>
    </div>
</div>